import React from 'react';

import { BrowserRouter as Router } from 'react-router-dom';

import { Provider } from 'react-redux';

import { PersistGate } from 'redux-persist/integration/react';

import { SkeletonTheme } from 'react-loading-skeleton';

import { ToastContainer } from 'react-toastify';

import { persistor, store } from './store';

import 'react-toastify/dist/ReactToastify.css';

import GlobalStyles from './styles/global';

import Routes from './routes';

import { skeletonTheme } from '../package.json';

import AppProvider from './hooks';

const App: React.FC = () => {

  // async function requestPermission() {
  //   const permission = await Notification.requestPermission();

  //   if (permission === 'granted') {
  //     // Generate Token

  //      await getToken(messaging, {
  //       vapidKey:
  //         'BCS5tfID80r55jdRnwAajpQNis5Ov0lyg7ZBsamu0OlwTHDHdVmLiIITZluUF2PO9Rqfe4IRunzAuWeTRcODWJA',
  //     });

  //     // Send this token  to server ( db)
  //   } else if (permission === 'denied') {
  //     //alert('You denied for the notification');
  //   }
  // }

  // useEffect(() => {
  //   // Req user for notification permission

  //   requestPermission();
  // }, []);

  // onMessage(messaging, payload => {
  //   // ...
  // });

  return (
    <Router>
      <SkeletonTheme
        color={skeletonTheme.color}
        highlightColor={skeletonTheme.highlightColor}
      >
      
        <Provider store={store}>
          <PersistGate loading={null} persistor={persistor}>
            <AppProvider>
              <Routes />
            </AppProvider>
          </PersistGate>
        </Provider>
      </SkeletonTheme>

      <ToastContainer />
      <GlobalStyles />
    </Router>
  );
};

export default App;
